module.exports = __webpack_public_path__ + "static/media/11(1).9079039a.jpg";